import React from "react";
import ProdottiTradotti from "../../statistiche/ProdottiTradotti";
import TranslationQuotaSummary from "../../traduzioni/TranslationQuotaSummary";
import { translationQuotaWarning } from "../../traduzioni/translationQuota";

function SubHeaderDB({ charCount, charLimit = null, charCountLoading, charCountError, titolo }) {
    const warning = translationQuotaWarning(charCount, charLimit);
    return (
        <div className={`${warning || charCountError ? "tastoRosso" : "tastoVerde"} white flex items-center justify-between pl4 pr4 h-100`}>
            <div className="b pt1 pb1">Naviga DB con scheda prodotto</div>
            <div className="pt1 pb1">Brand selezionato: <span className="b">{titolo}</span></div>
            <ProdottiTradotti />
            <TranslationQuotaSummary total={charCount} limit={charLimit} loading={charCountLoading} error={charCountError} />
        </div>
    );
}

export default SubHeaderDB;
